import React, {useState, useEffect} from "react";
import ReactDOM from 'react-dom/client'
import {MarkerClusterer, GridAlgorithm} from "@googlemaps/markerclusterer"
import MarkerInfoBox from "./MarkerInfoBox"

const Map = (props) => {
  const [currentMarkers, setCurrentMarkers] = useState([])

  const mapClusterRenderer = {
    render: (cluster) => {
      return new google.maps.Marker({
        icon: {
          url: 'data:image/svg+xml;charset=utf-8,' + encodeURIComponent(`<svg width="116" height="116" viewBox="0 -2 116 114" fill="none" xmlns="http://www.w3.org/2000/svg"><circle cx="58" cy="54" r="34" fill="#BAD4E7"/><circle cx="58" cy="54" r="28" fill="#77B3D5"/><circle cx="58" cy="54" r="20" fill="#EEF3F8" stroke="#214A66" stroke-width="4"/></svg>`),
          scaledSize: new google.maps.Size(136, 136)
        },
        label: {
          text: cluster.markers.length.toString(),
          // text: count.toString(),
          color: "#214a66",
          fontSize: "1.25rem",
        },
        position: cluster.position,
        // adjust zIndex to be above other markers
        zIndex: Number(google.maps.Marker.MAX_ZINDEX) + cluster.markers.length,
      })
    },
  }

  useEffect(() => {
    props.setCluster(() => {
      const cl = new MarkerClusterer({
        map: props.map,
        // markers: currentMarkers,
        renderer: mapClusterRenderer,
        algorithm: new GridAlgorithm({
          maxDistance: 750,
        })
      })

      const newClusterMarkers = []

      if (currentMarkers && currentMarkers.length) {

        props.activePins.forEach(pin => {
          const markerIdx = currentMarkers.findIndex((element) => element.pinID === `${pin.id}-base`)

          if (markerIdx < 0) return false

          currentMarkers[markerIdx].setVisible(pin.map)
          currentMarkers[markerIdx].setMap(pin.map ? props.map : null) //  ? props.map : null)

          if (pin.map) {
            newClusterMarkers.push(currentMarkers[markerIdx])
          }

          if (pin.wasSearched) {
            google.maps.event.trigger(currentMarkers[markerIdx], 'click')
          }

          // todo set the active pins to all be false for was searched flag. The below line is not sufficient.
          pin.wasSearched = false
        })
        if (props.mapLoaded) {
          const addMarkers = async () => {
            const test = await setTimeout(() => 'awaited', 5000)
            console.log('first addmarkers with maps loaded',test,  newClusterMarkers)
            newClusterMarkers.length && cl.addMarkers(newClusterMarkers)
          }
          addMarkers();

        }

        return cl
      }
    })
  }, [currentMarkers, props.mapLoaded])

  const infoWindow = new google.maps.InfoWindow() // shared infoWindow for all markers.

  useEffect(() => {
    if (props.listTarget !== null) {
      const target = currentMarkers.filter(m => m.pinID === `${props.listTarget}-base`)
      google.maps.event.trigger(target[0], 'click');
    }
  }, [props.listTarget])

  useEffect(() => {
    if (props.activePins) {
      if (currentMarkers.length !== 0) {
        // we have set some active markers.
        props.cluster.clearMarkers() // sending false as the nodraw param will force a re-render of the clusters
        const newClusterMarkers = []
        props.activePins.forEach(pin => {
          const markerIdx = currentMarkers.findIndex((element) => element.pinID === `${pin.id}-base`)
          if (markerIdx > -1) {
            if (pin.map) {
              newClusterMarkers.push(currentMarkers[markerIdx])
            }
            currentMarkers[markerIdx].setMap(pin.map ? props.map : null)
            currentMarkers[markerIdx].setVisible(pin.map)

            if (pin.wasSearched) {
              google.maps.event.trigger(currentMarkers[markerIdx], 'click')
            }
            // todo set the active pins to all be false for was searched flag. The below line is not sufficient.
            pin.wasSearched = false

            props.cluster.render() // google's documentation seems to be lying about this removing and re-rendering the markers.
          }
        })
        console.log('pre second markers')
        newClusterMarkers.length && props.cluster.addMarkers(newClusterMarkers)
      } else {
        props.activePins.map((activePin) => {
          const latLng = new google.maps.LatLng(Number(activePin.geofield.lat), Number(activePin.geofield.lon));

          const getCategoryIconURL = () => {
            const cats = props.mapData.categories
            const catIndex = cats.findIndex(cat => cat.id === activePin.category.id)
            if (catIndex !== -1) {
              return cats[catIndex].icon
            }
          }

          const generateCategoryIcon = (pin) => {
            const icon = getCategoryIconURL()
            if (pin.category.name.toLowerCase() === "venue") {
              return '';
            }

            let iconString = `<span class="sopa-map--marker_decorator ${icon ? 'has_icon' : 'default'}">`
            if (icon) {
              iconString += `<img src="${getCategoryIconURL()}" alt="" />`
            }
            iconString += `</span>`
            return iconString
          }

          const baseMarker = new RichMarker({
            position: latLng,
            animation: google.maps.Animation.DROP,
            // map: activePin.map ? props.map : null,
            shadow: 'none',
            visible: activePin.map,
            draggable: false,
            pinID: `${activePin.id}-base`,
            flat: true,
            categoryID: activePin.category.id,
            venueID: (activePin.venue !== null) ? activePin.venue.id : '',
            title: activePin.title,
            content: `
            <button data-name="${activePin.title}" class="sopa-map--marker ${(activePin.category.name.toLowerCase() === "venue") ? 'highlight' : 'standard'}">
            <div class="sopa-map--marker_base"></div>
            <div class="sopa-map--marker_base-hover"></div>
            ${generateCategoryIcon(activePin)}
            </button>`
          });

          // Setup a React root on a virtual DOM node and render our infoWindow component into that.
          const markerComponent = document.createElement("div");
          const root = ReactDOM.createRoot(markerComponent);
          root.render(<MarkerInfoBox categories={props.mapData.categories}
            handleToggleFilter={props.handleToggleFilter}
            pin={activePin}
            setActiveDetail={props.setActiveDetail}
            setDetailsPanelActive={props.setDetailsPanelActive}/>
          );

          baseMarker.addListener('click', () => {
            props.map.setCenter(baseMarker.getPosition() as google.maps.LatLng);
            props.map.panTo(baseMarker.getPosition() as google.maps.LatLng);
            infoWindow.close() // close the infoWindow if it's already open
            infoWindow.setOptions({
              ariaLabel: `Infowindow for ${activePin.title}`,
              pixelOffset: activePin.category.name.toLowerCase() === "venue" ? new google.maps.Size(0, -80) : new google.maps.Size(0, -54) // puts the tip of the infowindow at the top of the map pin.
            })
            infoWindow.setContent(markerComponent) // repopulate it with new content
            infoWindow.open(baseMarker.map, baseMarker) // show it to the user
          });
          setCurrentMarkers(prevState => {
            return [...prevState, baseMarker]
          })
        })
      }
    }
  }, [props.activePins])

  return (
    <>
    </>
  )
}

export default Map
